import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'input[type="link"][openLink]'
})
export class ShareLinkDirective {
  @Input('openLink') linkUrl: string;

  constructor() { }

  @HostListener('click')
  onClick() {
    if (this.linkUrl) {
      window.open(this.linkUrl, '_blank');
    }
  }
}